import { createAction } from '@reduxjs/toolkit'
import {
  Comunidad,
  PartidoJudicial,
  Provincia,
  OrganoJudicial,
  Colegio
} from 'src/interfaces/Catalog/index'

export const setComunidadAction = createAction<Comunidad>('catalog/SET_COMUNIDAD')
export const setComunidadesAction = createAction<Comunidad[]>('catalog/SET_COMUNIDADES')
export const setProvinciaAction = createAction<Provincia>('catalog/SET_PROVINCIA')
export const setProvinciasAction = createAction<Provincia[]>('catalog/SET_PROVINCIAS')
export const setPartidosJudicialesAction = createAction<PartidoJudicial[]>(
  'catalog/SET_PARTIDOS_JUDICIALES'
)
export const setOrganosJudicialesAction = createAction<OrganoJudicial[]>(
  'catalog/SET_ORGANOS_JUDICIALES'
)
export const setColegiosAction = createAction<Colegio[]>('catalog/SET_COLEGIOS')
